var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.showMemberDetail)?_c('div',[_c('data-board'),_c('active-user'),_c('data-table',{on:{"clickMemberList":_vm.clickMemberList}})],1):_c('div',[_c('activity-detail',{ref:"detail",on:{"back":_vm.back}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }